"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTimeSelectorNeoDark = exports.dateTimeSelectorNeoLight = exports.dateTimeSelectorNovoDark = exports.dateTimeSelectorNovo = exports.dateTimeSelector = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const dateTimeSelector = {
    fontSize: font_const_1.default.sizeSm,
    lineHeight: font_const_1.default.lineHeightSm,
    fontFamily: font_const_1.default.family,
    letterSpacing: undefined,
    fontWeight: undefined,
    // Input Box
    borderColor: color_const_1.default.cloudyBlue300,
    borderColorOpen: color_const_1.default.dodgerBlue,
    borderColorError: color_const_1.default.coral,
    borderSize: size_const_1.default.borderSizeDefault,
    borderRadius: 0,
    width: '330px',
    heightSmall: size_const_1.default.formItemSizeSmall,
    heightLarge: size_const_1.default.formItemSizeLarge,
    backgroundColor: color_const_1.default.white,
    backgroundColorDisabled: color_const_1.default.cloudyBlue100,
    color: color_const_1.default.pickledBluewood800,
    colorDisabled: color_const_1.default.cloudyBlue,
    placeholderColor: color_const_1.default.cloudyBlue,
    paddingVerticalSmall: `${parseInt(spacing_const_1.default.xxs, 10) - parseInt(size_const_1.default.borderSizeDefault, 10)}px`,
    paddingVerticalLarge: `${parseInt(spacing_const_1.default.xs, 10) - parseInt(size_const_1.default.borderSizeDefault, 10)}px`,
    paddingHorizontal: spacing_const_1.default.sm,
    iconColor: color_const_1.default.steel700,
    iconMinSize: size_const_1.default.medium,
    transitionTiming: timing_const_1.default.fast,
    iconMargin: spacing_const_1.default.xs,
    // Dropdown container
    containerZIndex: zIndex_const_1.default.z2000 + 500,
    containerBorderSize: size_const_1.default.borderSizeDefault,
    containerBorderColor: color_const_1.default.cloudyBlue300,
    containerShadowBlurRadius: size_const_1.default.small,
    containerShadowColor: color_const_1.default.cloudyBlue300,
    containerPadding: spacing_const_1.default.lg,
    containerBackgroundColor: color_const_1.default.white,
    containerAnimationDuration: timing_const_1.default.fast,
    footerPadding: spacing_const_1.default.md,
    footerBorderSize: size_const_1.default.borderSizeDefault,
    footerBorderColor: color_const_1.default.cloudyBlue300,
    containerBorderRadius: undefined,
    // Clear icon
    clearIconColor: color_const_1.default.cloudyBlue,
    clearIconHoverColor: color_const_1.default.steel700,
    isClassic: true,
};
exports.dateTimeSelector = dateTimeSelector;
const dateTimeSelectorNovo = {
    isClassic: false,
    // Typography
    ...light.body01,
    // Input Box
    borderColor: light.ui05,
    borderColorOpen: light.focus01,
    borderColorError: light.action03,
    borderSize: '2px',
    borderRadius: '6px',
    width: '330px',
    heightSmall: '32px',
    heightLarge: '40px',
    backgroundColor: light.ui05,
    backgroundColorDisabled: undefined,
    color: light.textColor01,
    colorDisabled: light.disabled02,
    placeholderColor: light.textColor02,
    paddingVerticalSmall: `${parseInt(light.spacing02, 10) - parseInt('2px', 10)}px`,
    paddingVerticalLarge: `${parseInt(light.spacing03, 10) - parseInt('2px', 10)}px`,
    paddingHorizontal: light.spacing04,
    iconColor: light.icon01,
    iconMinSize: '24px',
    transitionTiming: '150ms',
    iconMargin: light.spacing03,
    // Dropdown container
    containerZIndex: 2000 + 500,
    containerBorderSize: '1px',
    containerBorderColor: light.ui01,
    containerShadowBlurRadius: undefined,
    containerBorderRadius: '6px',
    containerShadowColor: (0, polished_1.rgba)(light.shadow01, 0.25),
    containerPadding: light.spacing06,
    containerBackgroundColor: light.ui06,
    containerAnimationDuration: timing_const_1.default.fast,
    footerPadding: light.spacing05,
    footerBorderSize: '1px',
    footerBorderColor: light.ui01,
    // Clear icon
    clearIconColor: light.icon01,
    clearIconHoverColor: light.action04,
};
exports.dateTimeSelectorNovo = dateTimeSelectorNovo;
const dateTimeSelectorNovoDark = {
    ...dateTimeSelectorNovo,
    // Input Box
    borderColor: dark.ui05,
    borderColorOpen: dark.focus01,
    borderColorError: dark.action03,
    backgroundColor: dark.ui05,
    backgroundColorDisabled: undefined,
    color: dark.textColor01,
    colorDisabled: dark.disabled02,
    placeholderColor: dark.textColor02,
    iconColor: dark.icon01,
    // Dropdown container
    containerBorderColor: dark.ui01,
    containerShadowColor: (0, polished_1.rgba)(dark.shadow01, 0.25),
    containerBackgroundColor: dark.ui06,
    footerBorderColor: dark.ui01,
    // Clear icon
    clearIconColor: dark.icon01,
    clearIconHoverColor: dark.action04,
};
exports.dateTimeSelectorNovoDark = dateTimeSelectorNovoDark;
const dateTimeSelectorNeoLight = {
    ...dateTimeSelectorNovo,
    borderColor: neoLight.ui05,
    borderColorOpen: neoLight.focus01,
    borderColorError: neoLight.action03,
    backgroundColor: neoLight.ui05,
    color: neoLight.textColor01,
    colorDisabled: neoLight.disabled02,
    placeholderColor: neoLight.textColor02,
    iconColor: neoLight.icon01,
    containerBorderColor: neoLight.ui01,
    containerShadowColor: (0, polished_1.rgba)(neoLight.shadow01, 0.25),
    containerBackgroundColor: neoLight.ui06,
    footerPadding: neoLight.spacing05,
    footerBorderColor: neoLight.ui01,
    clearIconColor: neoLight.icon01,
    clearIconHoverColor: neoLight.action04,
};
exports.dateTimeSelectorNeoLight = dateTimeSelectorNeoLight;
const dateTimeSelectorNeoDark = {
    ...dateTimeSelectorNovoDark,
    borderColor: neoDark.ui05,
    borderColorOpen: neoDark.focus01,
    borderColorError: neoDark.action03,
    backgroundColor: neoDark.ui05,
    color: neoDark.textColor01,
    colorDisabled: neoDark.disabled02,
    placeholderColor: neoDark.textColor02,
    iconColor: neoDark.icon01,
    containerBorderColor: neoDark.ui01,
    containerShadowColor: (0, polished_1.rgba)(neoDark.shadow01, 0.25),
    containerBackgroundColor: neoDark.ui06,
    footerBorderColor: neoDark.ui01,
    clearIconColor: neoDark.icon01,
    clearIconHoverColor: neoDark.action04,
};
exports.dateTimeSelectorNeoDark = dateTimeSelectorNeoDark;
